var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sales order") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sales-order",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2402103_business_chart_graph_growth_rise_icon",
    transform: "translate(3, 3)",
    fill: "#A36B40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9936525,1.4384529 C18.0491386,0.997790896 17.7347171,0.612211639 17.290828,0.557128889 L12.9074224,0.00630137978 C12.4635333,-0.0487813711 12.0751303,0.263354217 12.0196441,0.704016224 C11.964158,1.14467823 12.2785795,1.53025749 12.7224686,1.58534024 L15.1083729,1.87911491 L9.00489685,6.57950965 L7.96915546,4.83522254 C7.83968779,4.63325245 7.63623859,4.4680042 7.39579862,4.43128237 C7.15535866,4.37619962 6.89642331,4.44964328 6.71146949,4.59653062 L0.330562723,9.49889545 C-0.0393449161,9.79267012 -0.113326444,10.3251367 0.182599667,10.6923551 C0.330562723,10.8759642 0.534011924,10.9861297 0.755956507,11.0228516 C0.97790109,11.0412125 1.19984567,10.9861297 1.38479949,10.8576033 L6.95190946,6.56114873 L7.98765084,8.30543585 C8.11711852,8.50740593 8.32056772,8.67265418 8.56100768,8.70937602 C8.80144765,8.76445877 9.060383,8.6910151 9.24533682,8.54412777 L16.1626097,3.21946185 L15.8666835,5.6614638 C15.8481882,5.88179481 15.9036743,6.08376489 16.033142,6.24901315 C16.1626097,6.4142614 16.3475635,6.5244269 16.5695081,6.54278782 C16.7729573,6.56114873 16.9949018,6.50606598 17.1613603,6.37753956 C17.3278187,6.24901315 17.438791,6.04704306 17.4572864,5.84507297 L17.9936525,1.4384529 Z",
    id: "XMLID_5_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_4_",
    x: 9.94816133,
    y: 9.93955745,
    width: 2.90377496,
    height: 8.06044255
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: 5.37980199,
    y: 11.1880998,
    width: 2.90377496,
    height: 6.81190019
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 14.387053,
    y: 8.15854851,
    width: 2.90377496,
    height: 9.84145149
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1_",
    x: 1.01489185,
    y: 12.4550031,
    width: 2.90377496,
    height: 5.54499692
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesorder);
export default __webpack_public_path__ + "static/media/sales order.23e127dcebce7381ede413b5e4b02148.svg";
export { ForwardRef as ReactComponent };